export interface IDeferred<T = any> {
  promise: Promise<T>;
  resolve: (value: T | PromiseLike<T>) => void;
  reject: (reason?: any) => void;
}

export function create<T = any>() {
  /**
   * reference: https://github.com/moll/js-promise-defer/blob/master/index.js
   */
  const deferred: IDeferred<T> = Object.create({});
  deferred.promise = new Promise<T>(function (resolve, reject) {
    deferred.resolve = resolve;
    deferred.reject = reject;
  });
  return deferred;
}
